<template>
  <div class="home-page">
    <hero-slider :language="language" />
  </div>
</template>

<script>
import HeroSlider from '../components/HeroSlider.vue';

export default {
  name: 'Home',
  components: {
    HeroSlider
  },
  props: {
    language: {
      type: String,
      default: 'en'
    }
  }
};
</script>
